"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconNumberInputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var journey_model_1 = require("@athena-portal/journey-model");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var FalconNumberInputWidget = /** @class */ (function (_super) {
    __extends(FalconNumberInputWidget, _super);
    function FalconNumberInputWidget(props) {
        return _super.call(this, props) || this;
    }
    FalconNumberInputWidget.prototype.renderInputField = function () {
        return (0, jsx_runtime_1.jsx)("input", { type: "number", className: "form-control col-4 ".concat(this.getInputValidationClass()), min: this.getSetting("minValue", 0), max: this.getSetting("maxValue", 0), id: this.props.question.name, value: this.bindFromField(this.props.question.interactionField) || 0, onChange: this.handleOnChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, readOnly: this.isReadOnly() });
    };
    FalconNumberInputWidget = __decorate([
        (0, journey_model_1.events)([
            journey_model_1.Event.onChange,
            journey_model_1.Event.onClick,
            journey_model_1.Event.onFocus
        ]),
        (0, journey_model_1.settings)([
            { name: "minValue", type: journey_model_1.TypeDescriptions.Number },
            { name: "maxValue", type: journey_model_1.TypeDescriptions.Number }
        ]),
        __metadata("design:paramtypes", [Object])
    ], FalconNumberInputWidget);
    return FalconNumberInputWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.FalconNumberInputWidget = FalconNumberInputWidget;
//# sourceMappingURL=FalconNumberInputWidget.js.map